//pattern SINGLETON
export const appState = (() => {
  const state = {
    levelInd: 0,
    level: "Easy",
    templateInd: 0,
    template: "Number",
    matrix: [
      [0, 0, 1, 1, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 0, 1, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 1, 0],
    ],
    userInput: [],
  };

  state.userInput = Array((state.levelInd + 1) ** 2 * 25).fill(0);

  return {
    setState: (key, value) => (state[key] = value),
    setAllState: (newState) => {
      Object.keys(newState).forEach((key) => {
        if (state.hasOwnProperty(key)) {
          state[key] = newState[key];
        }
      });
    },
    getState: (key) => state[key],
    getAllState: () => ({ ...state }),
  };
})();
